import "./CareerOpportunities.module.css";
import Header from "@/reusable_sections/Header";
import HeroOverview from "./sections/HeroOverview";
import AboutIntroduction from "./sections/AboutIntroduction";
import GuidingPrinciples from "./sections/GuidingPrinciples";
import HeadingDescription from "./sections/HeadingDescription";
import BookYourFreeBalHarbourInspection from "./sections/BookYourFreeBalHarbourInspection";
import Footer from "@/reusable_sections/Footer";
export default function CareerOpportunitiesPage() {
  return <div>
      <Header />
      <HeroOverview />
      <AboutIntroduction />
      <GuidingPrinciples />
      <HeadingDescription />
      <BookYourFreeBalHarbourInspection />
      <Footer />
    </div>;
}